const scrollElementToBottom = (className: string): void => {
  const element = document.querySelector<HTMLElement>(`.${className}`);
  if (element) {
    element.scrollTop = element.scrollHeight;
  }
};

export default scrollElementToBottom;
